import React, { useState, useContext, useEffect } from "react";
import { MultiSelect } from "react-multi-select-component";
import styles from "./DetallePreguntaReemplazo.module.css";
import DOMPurify from "dompurify";
import GeneralContext from "../../context/GeneralContext";
import * as GeneralActions from "../../store/actions/generalActions";
import * as Funciones from "../../utils/funciones";
import * as Constantes from "../../utils/constantes";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository";
import Modal from "../Modals/Modal";

const DetallePreguntaReemplazo = ({indice, detalleReemplazo, listaSolicitudes, state, setState }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(userAux => userAux.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospectoAux => prospectoAux.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.isSelected || cotizacionAux.completado)[0]

    const [mostrarModal, setModal] = useState(false)
    const [textos, setTextos] = useState([])

    const onChangeOpcion = (campo, valor) => {
        generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, Constantes.TIPO_DATO_NUMERICO), indice))
    }

    const onChangeSolicitudes = (valores) => {
        if (cotizacion.listaDetalleReemplazo.length > 1) {
            if (valores.length !== 0) {
                let totalPolizas = cotizacion.listaDetalleReemplazo.find(det => det.idSolicitud !== detalleReemplazo.idSolicitud).polizas
                if (totalPolizas !== undefined) {
                    let pasar = false
                    totalPolizas.map(poliza => {
                        valores.map(valor => {
                            if (poliza.value === valor.value) {
                                setTextos(['Importante', 'Esta póliza ya no puede ser utilizada.'])
                                setModal(true)
                                pasar = false
                            } else {
                                pasar = true
                            }
                            return valor
                        })
                        return poliza
                    })
                    if (pasar) generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
                } else {
                    if (valores.length === state.listaPolizas.length) {
                        generalDispatch(GeneralActions.deleteDetalleReemplazo(detalleReemplazo.idSolicitud))
                        setState((state) => {
                            return {
                                ...state,
                                igualNroPol: false
                            }
                        })
                    }
                    generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
                }
            } else {
                generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
            }
        } else {
            generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
            if (valores.length === state.listaPolizas.length && state.listaSolicitudes.length > 1) {
                setState((state) => {
                    return {
                        ...state,
                        igualNroPol: false
                    }
                })
            } else {
                setState((state) => {
                    return {
                        ...state,
                        igualNroPol: true
                    }
                })
            }
        }
    }

    const onChangeCampoDetalleReemplazo = (campo, tipo, valor) => {
        if (campo === 'idSolicitud' && parseInt(valor) !== -1) {
            if (cotizacion.listaDetalleReemplazo !== undefined) {
                let selected = cotizacion.listaDetalleReemplazo.find(l => l.idSolicitud === parseInt(valor))
                if (selected !== undefined) {
                    setTextos(['¡Alerta!', 'Debe seleccionar otra solicitud.'])
                    setModal(true)
                } else {
                    generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, tipo), indice))
                    let tipoProducto = listaSolicitudes.find(sol => sol.idSolicitud === parseInt(valor)).tipoProducto
                    if (tipoProducto !== Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION) {
                        listarPolizas(1)
                        generalDispatch(GeneralActions.updateDetalleReemplazoField('flagReemplazoTraspaso', 1, indice))
                    }
                    generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoProd', Funciones.obtenerValor(tipoProducto, tipo), indice))
                }
            } else {
                generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, tipo), indice))
                let tipoProducto = listaSolicitudes.find(sol => sol.idSolicitud === parseInt(valor)).tipoProducto
                if (tipoProducto !== Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION) {
                    listarPolizas(1)
                    generalDispatch(GeneralActions.updateDetalleReemplazoField('flagReemplazoTraspaso', 1, indice))
                }
                generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoProd', Funciones.obtenerValor(tipoProducto, tipo), indice))
            } 
        }
        if (campo === 'flagReemplazoTraspaso') {
            generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, tipo), indice))
            listarPolizas(valor)
            generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', [], indice))
            generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoTraspaso', null, indice))
        } 
    }

    const listarPolizas = async (tipo) => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        let response = await SolicitudRepository.obtenerPolizas(cotizacion.asegurado.tipoDocumento.descripcion, cotizacion.asegurado.numeroDocumento, tipo)
        if(response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    listaPolizas: response.polizas
                }
            })
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(response.error))
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        if (state.listaPolizas.length === 0 && detalleReemplazo !== null && 
            detalleReemplazo.flagReemplazoTraspaso !== undefined && state.tieneRT) {
            listarPolizas(detalleReemplazo.flagReemplazoTraspaso)
        }
    }, [])

    return (
        <div className={styles.contenedor}>
            <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos}/>
            <div className={styles.detalle}>
                <div className={styles.solicitud}>
                    <label>Solicitud</label>
                    <select
                        value={detalleReemplazo !== null && detalleReemplazo.idSolicitud !== null ? detalleReemplazo.idSolicitud : -1}
                        onChange={(e) => onChangeCampoDetalleReemplazo('idSolicitud', Constantes.TIPO_DATO_NUMERICO, e.target.value, true)}
                        disabled={detalleReemplazo !== null && detalleReemplazo.idSolicitud !== null && listaSolicitudes.length === 1 ? true : false}
                    >
                        <option value={-1}>Seleccione</option>
                        {listaSolicitudes !== null
                            ? listaSolicitudes.map(solicitud => (
                                <option key={'opcion_' + solicitud.idSolicitud} value={solicitud.idSolicitud}>
                                    {solicitud.descripcion}
                                </option>
                            ))
                            : null
                        }
                    </select>
                </div>
            </div>
            {detalleReemplazo !== null && detalleReemplazo.idSolicitud !== null ? 
                <React.Fragment>
                    {detalleReemplazo.tipoProd === Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION ?
                        <div>
                            <div className={styles.opciones}>
                                <label className={styles.opcion}>
                                    <input
                                        type='radio'
                                        value={1}
                                        selected={detalleReemplazo !== null && detalleReemplazo.flagReemplazoTraspaso === 1}
                                        checked={detalleReemplazo !== null && detalleReemplazo.flagReemplazoTraspaso === 1}
                                        onChange={(e) => onChangeCampoDetalleReemplazo('flagReemplazoTraspaso', Constantes.TIPO_DATO_NUMERICO, e.target.value, false)}
                                        disabled={Deshabilitar() !== true ? false : true}
                                    />
                                    <p>Reemplazo</p>
                                </label>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label className={styles.opcion}>
                                    <input
                                        type='radio'
                                        value={2}
                                        selected={detalleReemplazo !== null && detalleReemplazo.flagReemplazoTraspaso === 2}
                                        checked={detalleReemplazo !== null && detalleReemplazo.flagReemplazoTraspaso === 2}
                                        onChange={(e) => onChangeCampoDetalleReemplazo('flagReemplazoTraspaso', Constantes.TIPO_DATO_NUMERICO, e.target.value, false)}
                                        disabled={Deshabilitar() !== true ? false : true}
                                    />
                                    <p>Traspaso</p>
                                </label>
                            </div>

                            <div className={styles.detalle}>
                                <div className={styles.solicitud}>
                                    <label>Póliza</label>
                                    <MultiSelect
                                        className={`${styles.multi_select_font} ${styles.multi_select_contenedor} ${styles.multi_select}`}
                                        options={state.listaPolizas
                                            .map(solicitud => ({label: (solicitud.numeroPoliza + ' - ' + solicitud.descripcionProducto), value: solicitud.numeroPoliza}))}
                                        hasSelectAll={false}
                                        disableSearch={true}
                                        closeOnChangedValue={false}
                                        value={detalleReemplazo !== null && detalleReemplazo.polizas !== undefined ? detalleReemplazo.polizas : []}
                                        onChange={onChangeSolicitudes}
                                        overrideStrings={{
                                            "selectSomeItems" : "Seleccione opciones",
                                            "allItemsAreSelected": "Todos las opciones seleccionadas.",
                                            "selectAll": "Select All",
                                            "search": "Search"
                                        }}
                                        disabled={Deshabilitar() !== true ? false : true}
                                    />
                                </div>
                            </div>

                            {detalleReemplazo.flagReemplazoTraspaso === 2
                                ? <React.Fragment>
                                    <div className={styles.opciones}>
                                        <label className={styles.opcion}>
                                            <input
                                                type='radio'
                                                value={1}
                                                selected={detalleReemplazo !== null && detalleReemplazo.tipoTraspaso === 1}
                                                checked={detalleReemplazo !== null && detalleReemplazo.tipoTraspaso === 1}
                                                onChange={(e) => onChangeOpcion('tipoTraspaso', e.target.value)}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <p>Opción 1</p>
                                        </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <label className={styles.opcion}>
                                            <input
                                                type='radio'
                                                value={2}
                                                selected={detalleReemplazo !== null && detalleReemplazo.tipoTraspaso === 2}
                                                checked={detalleReemplazo !== null && detalleReemplazo.tipoTraspaso === 2}
                                                onChange={(e) => onChangeOpcion('tipoTraspaso', e.target.value)}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <p>Opción 2</p>
                                        </label>
                                    </div>

                                    <div className={styles.detalle_texto}>
                                        <div className={styles.texto}>
                                            <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '1')
                                            )}} />
                                            <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '2')
                                            )}} />
                                        </div>

                                        <div className={styles.texto}>
                                            <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '3')
                                            )}} />
                                            <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '4')
                                            )}} />
                                        </div>
                                    </div>
                                </React.Fragment>
                                : null
                            }
                        </div>
                        : 
                        <div className={styles.detalle}>
                            <div className={styles.solicitud}>
                                <label>Reemplaza la(s) póliza(s)</label>
                                <MultiSelect
                                    className={`${styles.multi_select_font} ${styles.multi_select_contenedor} ${styles.multi_select}`}
                                    options={state.listaPolizas
                                        .map(solicitud => ({label: (solicitud.numeroPoliza + ' - ' + solicitud.descripcionProducto), value: solicitud.numeroPoliza}))}
                                    hasSelectAll={false}
                                    disableSearch={true}
                                    closeOnChangedValue={false}
                                    value={detalleReemplazo !== null && detalleReemplazo.polizas !== undefined ? detalleReemplazo.polizas : []}
                                    onChange={onChangeSolicitudes}
                                    overrideStrings={{
                                        "selectSomeItems" : "Seleccione opciones",
                                        "allItemsAreSelected": "Todos las opciones seleccionadas.",
                                        "selectAll": "Select All",
                                        "search": "Search"
                                    }}
                                    disabled={Deshabilitar() !== true ? false : true}
                                />
                            </div>
                        </div>
                    }
                </React.Fragment>
                : null
            }
        </div>
    )
}

export default DetallePreguntaReemplazo;